import React from 'react';
import { Check, CloudOff, Loader2, PencilLine, TriangleAlert } from 'lucide-react';

const MAP = {
  idle: { label: 'Tutto salvato', cls: 'text-slate-500 bg-slate-50 border-slate-200', Icon: Check },
  saved: { label: 'Salvato', cls: 'text-emerald-700 bg-emerald-50 border-emerald-200', Icon: Check },
  saving: { label: 'Salvataggio…', cls: 'text-indigo-700 bg-indigo-50 border-indigo-200', Icon: Loader2 },
  dirty: { label: 'Modifiche non salvate', cls: 'text-amber-700 bg-amber-50 border-amber-200', Icon: PencilLine },
  offline: { label: 'Connessione assente — da sincronizzare', cls: 'text-orange-800 bg-orange-50 border-orange-300', Icon: CloudOff },
  error: { label: 'Errore di salvataggio', cls: 'text-red-700 bg-red-50 border-red-300', Icon: TriangleAlert },
};

export const QcrStatusBadge = ({ status }) => {
  const map = {
    'Bozza': 'bg-slate-500',
    'In compilazione': 'bg-amber-600',
    'Completato': 'bg-emerald-700',
    'Annullato': 'bg-red-700',
  };
  return <span className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-semibold text-white ${map[status] || 'bg-slate-400'}`}>{status || '—'}</span>;
};

export const AutosaveIndicator = ({ status, lastSavedAt, pendingCount = 0, onRetry }) => {
  const { label, cls, Icon } = MAP[status] || MAP.idle;
  const time = lastSavedAt
    ? new Date(lastSavedAt).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
    : null;
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-medium ${cls}`}
      data-testid="qcr-autosave-indicator"
      data-autosave-status={status}
    >
      <Icon className={`w-3.5 h-3.5 ${status === 'saving' ? 'animate-spin' : ''}`} />
      <span data-testid="qcr-autosave-label">{label}</span>
      {pendingCount > 0 && <span className="font-semibold">({pendingCount} in coda)</span>}
      {time && <span className="text-slate-500 font-normal" data-testid="qcr-last-saved">Ultimo salvataggio: {time}</span>}
      {(status === 'error' || status === 'offline') && onRetry && (
        <button type="button" onClick={onRetry} className="underline font-semibold" data-testid="qcr-autosave-retry">
          Riprova
        </button>
      )}
    </div>
  );
};
